import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { APP_ID, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ImaginaeToken } from 'src/app/models/imaginae-token.model';

@Injectable({
  providedIn: 'root',
})
export class InfoService {
  private isBrowser: Boolean = false;
  private isServer: Boolean = false;
  private token: ImaginaeToken;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(APP_ID) private appId: string
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.isServer = isPlatformServer(platformId);
    console.log(this.isBrowser ? 'Is Platform Browser' : 'Is Platform Server');
    this.token = new ImaginaeToken();
  }

  isPlatformBrowser() {
    return this.isBrowser;
  }

  isPlatformServer() {
    return this.isServer;
  }
}
